import React, { Component } from 'react';
import AbacusSelect from '../Components/AbacusSelect';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {ApxReportMenu} from '../Enums/Enums';
import AbacusTextField from '../Components/AbacusTextField';
import Util from './../Util/Util';

/// DocumentRequest Class. 
class DocumentRequest extends Component {
  // Variables
  reportGroup = ApxReportMenu.Finance;
  token;
  data;
  documentTypes = [
    {value:"ClientApplication",text:"Onboarding"},
    {value:"Chargeback",text:"Chargeback"}
  ];
  currentState={
    applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c"
  };

  applicationTypes = [
    {value:"a5d17698-48fe-4f0a-84fa-19857406a1ae",text:"Abacus Law"},
    {value:"418e1b76-3f46-4e01-8720-dcaf1ece8115",text:"Amicus Attorney"},
    {value:"14ac405f-1b0c-46a4-b10f-01d4071ca13c",text:"Amicus Cloud"},
    {value:"f04c4d2b-57ad-409b-9f60-703d00187a4e",text:"Office Tools"},
    {value:"c5dd2f9d-3810-46c4-830b-dafb5d7fccf9",text:"Office Tools Cloud"},
  ];

  // Constructor initiate callback methods and sets initial state
  constructor(props) {
    super(props);  

    this.data = props.data;
    this.data.Service.SendDocumentUploadURLCallback = this.sendCallback.bind(this);

    // Keep state in current state because the state can be changed only once per event.
    this.clearState();
    
    // Set state
    this.state = {...this.currentState}
  }

  // callback for showing Progress circle.
  showProgress(show){
    this.setState({
      showProgress:show
    });
  }

  // Drop Down Change Events
  dropDownChange(controlName, event){
    if(controlName === "ApplicationType"){
      this.currentState.applicationType = event.target.value;
    }else if(controlName === "DocumentType"){
      this.currentState.documentType = event.target.value;
      this.currentState.showMerchantID = this.currentState.documentType === "Chargeback";
    }

    this.setControlsState();
  }

  // Text Field Change Events
  textFieldChange(control, event){
      this.currentState.IsValid = false;
      if(control === "CustomerID"){
        this.currentState.customerNumber = event.target.value;
      }else if(control === "RecipientName"){
        this.currentState.recipientName = event.target.value;
      }else if(control === "MerchantID"){
        this.currentState.merchantID = event.target.value;
      }else if(control === "TransactionID"){
        this.currentState.transactionID = event.target.value;
      }else if(control === "Email"){
        this.currentState.email = event.target.value;
      }else if(control === "RequestDocument"){
        this.currentState.requestDocument = event.target.value;
      }else if(control === "AccountID"){
        this.currentState.accountID = event.target.value;
      }
    
    this.isValidEmail();
    this.validateEmpty();

    this.setControlsState();
  }

  isValidEmail(){
    let util = new Util();
      if(util.trim(this.currentState.email).length !== 0 )
      {
        let isValid = util.isValidEmailAddress(this.currentState.email);
        if(!isValid){
          this.currentState.Email_ErrorText = "Invalid Email Address.";
          this.currentState.Email_Error = true;
          this.currentState.IsValid = false;
        }else{
          this.currentState.Email_ErrorText = "";
          this.currentState.Email_Error = false;
          this.currentState.IsValid = true;
        }
      }else{
        this.currentState.Email_ErrorText = "";
        this.currentState.Email_Error = false;
        this.currentState.IsValid = true;
      }
  }

  validateEmpty(){
    let util = new Util();
    if(util.trim(this.currentState.customerNumber) === "" ||
      util.trim(this.currentState.email) === "" ||
      util.trim(this.currentState.recipientName) === "" ||
      util.trim(this.currentState.requestDocument) === "" ||
      util.trim(this.currentState.accountID) === ""
    ){
      this.currentState.IsValid = false;
    }
  }

  clearState(){
    
    this.currentState = {
        documentType:"ClientApplication",
        customerNumber:"",
        applicationType:"14ac405f-1b0c-46a4-b10f-01d4071ca13c",
        showProgress: false,
        sendTo: "",
        showMerchantID: false,
        recipientName:"",
        requestDocument:"",
        email:"",
        accountID:"",
        IsValid: false,
         transactionID:""
    }
  }

  /// Adjust controls and set states. State can be set only 
  /// once so group all events changes.
  setControlsState(){
    
    // Final set state
    this.setState({...this.currentState});
  }

    send(){
      let documentUploadURL ={
        IsChargeback:this.state.documentType === "Chargeback",
        Document:this.state.requestDocument,
        merchantID: this.state.merchantID,
        Email: this.state.email,
        RecipientName: this.state.recipientName,
        Representative:this.data.Login.FirstName + " " + this.data.Login.LastName,
        AccountID: this.state.accountID,
        TransactionID: this.state.transactionID
      }

      this.data.Service.SendDocumentUploadURL(documentUploadURL,this.token);
      this.clear();
    }

    sendCallback(){
      this.data.Service.GetAccountManagementHistoryList(this.token,1);
    }

    clear(){
      this.currentState = {
        documentType:"ClientApplication",
        customerNumber:"",
        applicationType:"14ac405f-1b0c-46a4-b10f-01d4071ca13c",
        showProgress: false,
        sendTo: "",
        showMerchantID: false,
        recipientName: "",
        requestDocument: "",
        email:"",
        accountID:"",
        transactionID:"",
        IsValid: false
      }
      
      // Clear Grid
      this.props.data.Service.GetAccountManagementHistoryListCallback([]);

      this.props.data.Service.FirmNameCallback("");

      this.setControlsState();
    }

  buttonStyle={
    width:"130px",
    marginTop:"12px"
  }

  onBlur(){
    this.getAPXTokenForCustomer();
  }

  getAPXTokenForCustomer(){
    let util = new Util();
    if(util.trim(this.state.customerNumber).length === 0 ){
      return;
    };
    let request = {
      CustomerIdentifier:this.state.customerNumber,
      ApplicationIdentifier:this.state.applicationType
    }

    this.props.data.Service.GetAPXTokenForCustomer(request, this.getList.bind(this));
  }

  getList(token){
    this.token = token;
    this.data.Service.GetAccountManagementHistoryList(this.token,1);
  }

  /// Render html
  render() {
    return (
      <div>
        <Grid container spacing={1}>
            <Grid item xs={12}>
              <div style={{height:"30px"}}></div>
            </Grid>

            <Grid item xs={4}>
              <AbacusSelect error={false} style={{width:"300px"}} value={this.state.applicationType} list={this.applicationTypes} label="Application"  onChange={this.dropDownChange.bind(this,"ApplicationType")}></AbacusSelect>
            </Grid>
            <Grid item xs={4}>  
              <AbacusTextField onBlur={this.onBlur.bind(this)} value={this.state.customerNumber} style={{marginTop:"0px",width:"300px"}} Name="Customer ID" helperText="" onChange={this.textFieldChange.bind(this,"CustomerID")}></AbacusTextField>
            </Grid>
            <Grid item xs={4}>
                <AbacusTextField value={this.state.recipientName} style={{marginTop:"0px",width:"300px"}} Name="Recipient Name" helperText="" onChange={this.textFieldChange.bind(this,"RecipientName")}></AbacusTextField>
            </Grid>

            <Grid item xs={8}>
                <AbacusTextField value={this.state.email} errorText={this.state.Email_ErrorText} error={this.state.Email_Error} style={{marginTop:"0px",width:"640px"}} Name="Email" helperText="" onChange={this.textFieldChange.bind(this,"Email")}></AbacusTextField>
            </Grid>
            <Grid item xs={4}>
                <AbacusSelect error={false} style={{width:"300px"}} value={this.state.documentType} list={this.documentTypes} label="Document Type"  onChange={this.dropDownChange.bind(this,"DocumentType")}></AbacusSelect>
            </Grid>            
            <Grid item xs={8}>
              <AbacusTextField value={this.state.accountID} style={{marginTop:"0px",width:"640px"}} Name={"Account ID"} helperText="" onChange={this.textFieldChange.bind(this,"AccountID")}></AbacusTextField>           
            </Grid>
            <Grid item xs={4}>              
              {(this.state.documentType === "Chargeback")? <AbacusTextField value={this.state.transactionID} style={{marginTop:"0px",width:"320px"}} Name={"Transaction ID"} helperText="" onChange={this.textFieldChange.bind(this,"TransactionID")}></AbacusTextField>:null}
            </Grid>
            <Grid item xs={6}>
            </Grid>

            <Grid item xs={8}>
                <AbacusTextField value={this.state.requestDocument} style={{marginTop:"0px",width:"640px"}} Name="Request Document" helperText="" onChange={this.textFieldChange.bind(this,"RequestDocument")}></AbacusTextField>
            </Grid>
            <Grid item xs={2}>
            {!this.state.showProgress?<Button  style={this.buttonStyle} onClick={this.clear.bind(this)} variant="outlined" color="primary">
                CLEAR
              </Button>:null}
            </Grid>
            <Grid item xs={2}>
            {!this.state.showProgress?<Button style={this.buttonStyle} disabled={!this.state.IsValid} onClick={this.send.bind(this)} variant="contained" color="primary">
                SEND
              </Button>:<CircularProgress style={{marginTop:"0px"}} />}
            </Grid>
        </Grid>
      </div>
    );
  }
}

export default DocumentRequest;